export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "Enabled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enabled"])},
        "Triggered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Triggered"])},
        "times": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["times"])},
        "Edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "There aren't any automations here yet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There aren't any automations here yet"])},
        "Create Automation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Automation"])}
      },
      "en-US": {
        "Enabled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enabled"])},
        "Triggered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Triggered"])},
        "times": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["times"])},
        "Edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "There aren't any automations here yet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There aren't any automations here yet"])},
        "Create Automation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Automation"])}
      }
    }
  })
}
